interface Item {
  id: number;
  name: string;
}

export function getIdFromMax(array: Item[]): number {
  if (array.length === 0) {
    return 0;
  }

  const numericIds = array
    .map((obj) => Number(obj.id))
    .filter((id) => !Number.isNaN(id));

  if (numericIds.length === 0) {
    return 0;
  }

  return Math.max(...numericIds) + 1;
}

export const sanitizeTextWithSeparators = (value: string) =>
  value.replace(/[^a-zA-Z0-9À-ÖØ-öø-ÿ\s_.-]/g, "");

export const sanitizeProjectName = (value: string) =>
  value.replace(/[^a-zA-Z0-9À-ÖØ-öø-ÿ_.-]/g, "");

export const LABELISATION_TYPES = [
  { id: "RECTANGLE_BOXING", text: "RECTANGLE BOXING" },
  { id: "PLATE", text: "PLATE" },
  { id: "PLATE_TEXT", text: "PLATE_TEXT" },
  { id: "CLASSIF", text: "CLASSIFICATION" },
  { id: "SEGMENTATION", text: "SEGMENTATION" },
  { id: "VIDEO", text: "VIDEO" },
];